<template>
  <div class="pecipeList">
    <div>
      <el-radio-group v-model="conditions" @change="tabConditions">
        <el-radio-button label="m">按月</el-radio-button>
        <el-radio-button label="y">按年</el-radio-button>
      </el-radio-group>
    </div>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="月份区间" label-width="70px" v-if="conditions === 'm'">
        <el-date-picker
            @input="search"
            v-model="searchForm.monthTime"
            value-format="yyyy-MM-dd"
            type="monthrange"
            style="width: 220px"
            unlink-panels
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="年份区间" label-width="70px" v-if="conditions === 'y'">
        <el-date-picker
            @input="search"
            v-model="searchForm.startYear"
            type="year"
            value-format="yyyy-MM-dd"
            style="width: 220px"
            placeholder="开始年份"
            unlink-panels>
        </el-date-picker>
        -
        <el-date-picker
            @input="search"
            v-model="searchForm.endYear"
            type="year"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            unlink-panels
            placeholder="结束年份">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="代理商" label-width="60px">
        <DicInput @fieldId="fieldId($event,'operatorId')" :dicType="6"></DicInput>
      </el-form-item>
      <el-form-item label="设备类型">
        <DicInput @fieldId="fieldId($event,'TypeId')" :dicType="1"></DicInput>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <!--      <el-button type="warning" style="float: right" @click="viewList">查看表格<i class="el-icon-view el-icon&#45;&#45;right"></i>-->
      <!--      </el-button>-->
    </div>
    <div ref="mis4" style="width:100%;height:650px;"></div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import echarts from 'echarts/lib/echarts'
// // 再引入你需要使用的图表类型，标题，提示信息等
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/aria'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import {getDay} from "@/service/common";
import DicInput from "@/components/DicInput";

export default {
  name: "pecipeList",
  data() {
    return {
      tableData: [],
      searchForm: {
        monthTime: [],
        startYear: '2021',
        endYear: '2022',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      conditions: 'm',
    }
  },
  components: {
    Pagination,
    DicInput
  },
  methods: {
    // -------------------查询条件/清空-------------------
    search() {
      this.tabConditions()
    },
    clear() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.searchForm = {
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
        operatorId: '',
        TypeId: '',
      }
      this.init()
    },
    // viewList() {
    //   this.$router.push('/recipeStatistics/salesList')
    // },
    echarts(a, b, c) {
      this.mis4 = echarts.init(this.$refs.mis4);
      this.mis4.setOption(
          {
            legend: {
              data: b
            },
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: a
            },
            yAxis: {
              type: 'value'
            },
            series: c
          }
      )
    },
    tabConditions() {
      let url = ''
      let data = {}
      let start, end
      if (this.conditions === 'm') {
        url = '/Statistics/MaintainStatistic/GetMonthSatisfactionModel'
        start = this.searchForm.monthTime[0]
        end = this.searchForm.monthTime[1]
      } else {
        url = '/Statistics/MaintainStatistic/GetYearSatisfactionModel'
        start = this.searchForm.startYear
        end = this.searchForm.endYear
      }
      data = {
        start: start,
        end: end,
        TypeId: this.searchForm.TypeId,
        operatorId: this.searchForm.operatorId,
        groupbBy: this.conditions
      }
      this.init(url, data)
    },
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    contains(array,target){ // 数组对比
      for(let i in array){
        if(array[i]===target){
          return true;
        }
        return  false
      }
    },
    containsObj(array,target){ // 对象对比
      for(let i in array){
        if(array[i].name===target.name){
            return true;
        }
        return  false;
      }
    },
    // list
    init(url, data) {
      this.axios
          .get(url, {params: data})
          .then((res) => {
            let data1 = [];
            let data2 = [];
            let data3 = [];
            //产生分组
            let groups=[];
            for(var i in res){
              var target=null;
              for(var b in groups){
                if(groups[b].key==res[i].title){
                  target=groups[b];
                  break;
                }
              }
              if(target==null){
                groups.push({key:res[i].title,data:[res[i]]})
              }else{
                target.data.push(res[i])
              }
            }
            //清洗年月
            groups[0].data.forEach(j=>{
              data1.push(j.year + "-" + j.month)
            })
            groups.forEach(j=>{
              data2.push(j.key)
              let x = {
                name: j.key,
                type: 'line',
                stack: '总量',
                data: []
              }
              for(let i in j.data){
                x.data.push(j.data[i].count)
              }
               data3.push(x)
            })
            this.echarts(data1, data2, data3)
          })
    }
  },
  mounted() {
    //
    this.tabConditions()
  }
}
</script>

<style lang="scss" scoped>
.pecipeList {
  text-align: start;
  min-height: 800px;

  & > div:nth-child(1) {
    margin-bottom: 20px;

    .el-button {
      box-shadow: 0 4px 8px #FFE0BA;
    }
  }

  .decBox {
    padding-right: 20px;

    i {
      font-style: normal;
    }
  }

  .el-form {
    display: flex;
    flex-wrap: wrap;
  }

  .doctorDetails {
    .titleName {
      font-weight: bold;
      padding-right: 10px;
    }

    .detailsLine {
      padding-bottom: 20px;
    }

    .tagList {
      margin-right: 10px;
    }
  }
}
</style>